import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=7926e5f2&scoped=true&lang=pug&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=7926e5f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7926e5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7926e5f2')) {
      api.createRecord('7926e5f2', component.options)
    } else {
      api.reload('7926e5f2', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=7926e5f2&scoped=true&lang=pug&", function () {
      api.rerender('7926e5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/basic/Icon.vue"
export default component.exports